import { assert_array_includes, assert_is_safe_number, assert_true } from '@shared/asserts/utils_asserts';
import { ENUM__environment_type } from '@shared/enums/ENUM__environment_type';
import { logw } from '@shared/utils/utils_logs';

export function init_constants_environment(
  constants_object: Record<string, number | boolean | string>,
  environment_object: Record<string, string>,
  prefix: string,
): void {
  let fields_in_typescript = Object.keys(constants_object);
  let fields_in_file = Object.keys(environment_object);

  let all_vars_exists_in_typescript = check_existence_from_file_in_typescript(fields_in_typescript, fields_in_file);
  let all_vars_exists_in_file = check_existence_from_typescript_in_file(fields_in_typescript, fields_in_file);

  copy_vars_from_file_to_typescript(constants_object, environment_object, fields_in_typescript, fields_in_file);

  assert_true(all_vars_exists_in_typescript);
  assert_true(all_vars_exists_in_file);

  let environment_key = `${prefix}_APP_ENVIRONMENT`;

  assert_array_includes(Object.values(ENUM__environment_type), (constants_object as any)[environment_key]);
}

function check_existence_from_file_in_typescript(fields_in_typescript: string[], fields_in_file: string[]): boolean {
  const missing_vars = fields_in_file.filter(varName => !fields_in_typescript.includes(varName));

  if (missing_vars.length > 0) logw(`env variables not existing in TypeScript:\n${JSON.stringify(missing_vars)}`);

  return missing_vars.length === 0;
}

function check_existence_from_typescript_in_file(fields_in_typescript: string[], fields_in_file: string[]): boolean {
  const missing_vars = fields_in_typescript.filter(varName => !fields_in_file.includes(varName));

  if (missing_vars.length > 0) logw(`constants variables not existing in env file:\n${JSON.stringify(missing_vars)}`);

  return missing_vars.length === 0;
}

function copy_vars_from_file_to_typescript(
  constants_object: Record<string, number | boolean | string>,
  environment_object: Record<string, string>,

  fields_in_typescript: string[],
  fields_in_file: string[],
) {
  for (const variable_name of fields_in_file) {
    if (!fields_in_typescript.includes(variable_name)) continue;

    let value = environment_object[variable_name];

    value = strip_single_quotes(value);

    if (value === undefined || value === null || value === '') {
      logw(`Environment variable is empty: ${variable_name}`);

      (constants_object as any)[variable_name] = '';
    } else if (variable_name.endsWith(`_BOOLEAN`)) {
      (constants_object as any)[variable_name] = value.to_boolean();
    } else if (variable_name.endsWith(`_NUMBER`)) {
      (constants_object as any)[variable_name] = parse_number(value);
    } else {
      (constants_object as any)[variable_name] = value;
    }
  }
}

function strip_single_quotes(input: string): string {
  if (input.startsWith("'")) input = input.slice(1);
  if (input.endsWith("'")) input = input.slice(0, -1);

  return input;
}

function parse_number(value: string): number {
  value = value.trim_lowercase();

  value = value.replaceAll('_', '');

  let out = parseFloat(value);

  assert_is_safe_number(out);

  return out;
}
